const Footer = () => (
  <div className="footer fixed">
    <div className="container main-footer">
      <a href="/guides/image-upload-guide.pdf" target="_blank" download>
        User Image Upload Guide
      </a>
      <img alt="homecare medical logo" src="/images/whakarongorau-logo-horiz-rev.png" />
    </div>
    <div className="container super-footer">
      <p>
        &copy; 2021 Whakarongorau Aotearoa // New Zealand Telehealth Services. All rights reserved.
        We value your
        <a href="https://whakarongorau.nz/privacy">privacy.</a>
      </p>
    </div>
  </div>
);

export default Footer;
